import React, { Component } from "react";
import { Row, Col } from "antd";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import CarouselComponent from "../../../../CommonComponents/Carousel/CarouselComponent";
import BalanceCards from "../../../../CommonComponents/BalanceCards/BalanceCards";
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import DashboardSummary from "../../../../CommonComponents/PageSummary/DashboardSummary/DashboardSummary";
import {
  SectionTopHeading,
  GreyBackgroundSection,
  CommonCard,
  FixedWidth,
  SemiDarkerDivider,
  IDSectionHeading,
  InvestmentDashboardBody,
  InvestmentPerformanceWrapper,
  MarketMovementWrapper,
  MarketMovementTitle,
  MarketMovementValue,
  TabFooter,
  NotifyText,
  InfoMsg,
  GeneralCustomDiv
} from "../../../../CommonComponents/commonStyles";
import InvestmentPerformanceMobile from "./Components/InvestmentPerformanceMobile/InvestmentPerformanceMobile";
import InvestmentPerformance from "./Components/InvestmentPerformance/InvestmentPerformance";
import {
  PrimaryButton,
  GhostButton,
  LinkNavigatorButton
} from "../../../../CommonComponents/CTA/Buttons";
import {
  renderTitleGrid,
  renderDateGrid,
  renderFixGrid,
  renderDateGrid1,
  renderFixGrid1
} from "../../../../utils/cardGrid";
import {
  disabledValidator,
  disabledText1
} from "../../../../utils/disabledHandler";
import { startDate, todayDate } from "../../../../utils/commonUtil";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";
import DashboardTabs from "./Components/Tabs/Tabs";
/*************************/
import { fetchInvestmentDashBoardData } from "./actions";
import { TooltipCircle, MarketMovementTooltip } from './Components/Tooltip/styles';
import tooltipIcon from "../../../../assets/icons/shape.svg";
import { initiateTracking } from '../../../../utils/commonUtil';
import { selectHeader } from "../../../../actions/globalActions";
import { ContentProvider, ContentMessage, Types } from "../../../../CommonComponents/ContentMessages";
import "../../../AccountSummary/Pages/AccountSummary.css";
import { CarouselController } from "./Components/Tabs/styles";
import { investmentDashboardDerivedStates } from './selectors';
import PropTypes from 'prop-types';
import { GeneralButton,TooltipWrapper } from "../../../../CommonComponents/Commons/commonComponents";

class InvestmentDashboard extends Component {

  constructor(props) {
    super(props);
    this.pageTitle = 'Investment Overview';    
  }

  setPageTitle = (title='') => {    
    if(title) {
      this.pageTitle = title;
    }
  }

  getPageTitle = () => {
    return this.pageTitle;
  }

  componentDidMount() {
    this.props.requestData({
      metaData: [
        {
          method: 'GET',
          url: `/donor-portal/api/investment/${
            getPrimaryAccount().userId
          }/findInvestmentSummaryByAccountIdStartDateAndEndDate?startDateStr=${startDate(
            90
          )}&endDateStr=${todayDate()}`,
          page: 'investmentDashboard'
        },
        {
          method: 'GET',
          url: `/donor-portal/api/investment/${
            getPrimaryAccount().userId
          }/findByAccountIdStartDateAndEndDate?startDateStr=${startDate(
            90
          )}&endDateStr=${todayDate()}`,
          page: 'investmentDashboard'
        },
        {
          method: 'GET',
          url: `/donor-portal/api/exchange/${
            getPrimaryAccount().userId
          }/findRecurringExchangesByAccountId?isDashboard=true`,
          page: 'investmentDashboard'
        }
      ]
    });
    window.scrollTo(0, 0);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.accountID !== this.props.accountID) {
      this.props.history.push('/');
    }
  }
  dolarFormater(n, currencySign) {
    let currency = n.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    if (currency.charAt(0) === '-') {
      return `- ${currencySign}${currency.substring(1, currency.length)}`;
    }
    return `${currencySign}${currency}`;
  }

  goToIOD() {
    initiateTracking(
      'investmentPerformance',
      this.getPageTitle(),
      '',
      'View Investment Performance'
    );
    this.props.history.push('/investments/details');
  }

  goToPage = (pathName, query, selectedHeader) => {
    selectedHeader && this.props.selectHeader(selectedHeader);
    if (query) {
      this.props.history.push(pathName + query);
    } else {
      this.props.history.push(pathName);
    }
  };

  goFromCardsToPage = (e, pathName, query, selectedHeader) => {
    e.preventDefault();
    selectedHeader && this.props.selectHeader(selectedHeader);
    if (query) {
      this.props.history.push(pathName + query);
    } else {
      this.props.history.push(pathName);
    }
  }

  goToExchanges = data => {
    if (data.txnId) {
      if (data.exchangetype === 'To TIFF') {
        this.goToPage(
          `/view-edit-tiff-into/${data.txnId}/edit`
        );
      } else if (data.exchangetype === 'From TIFF') {
        this.goToPage(
          `/view-edit-tiff-from/${data.txnId}/edit`
        );
      } else {
        this.goToPage(
          `/investments/recommend-an-exchange/${data.txnId}/view?type=onetime`
        );
      }
    } else {
      this.goToPage(
        `/investments/recommend-an-exchange/${data.exchScheduleId}/view?type=recurring`
      );
    }
  };

  render() {
    const {
      accData,
      recentData,
      isLoadingAccount,
      isLoadingRecent,
      recurringData,
      isLoadingRecurring
    } = this.props;

    let primaryAccount = getPrimaryAccount();

    if (
      typeof accData !== 'null' &&
      typeof accData === 'object' &&
      primaryAccount
    )
      accData.roleAccess = primaryAccount.role.access;

    if (isLoadingAccount) return <Preloader data-test="preLoader"/>;
    let BalanceCardsConfiguration = [
      {
        heading: <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="Current Balance" property="field_page_title" defaultMessage="Current Balance" />,
        balance: accData.currentBalance,
        text: <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} html={true} page="Current Balance" property="field_link_tooltip" defaultMessage="Balance in your donor-advised fund after the previous day’s trading cycle is completed" />,
        url: '/',
        buttonName: 'View account summary',
        comingSoon: false,
        pageName: 'Investment Dashboard'        
      },
      {
        heading: <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="Available Balance" property="field_page_title" defaultMessage="Available Balance" />,
        balance: accData.availableBalance,
        text: <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} html={true} page="Available Balance" property="field_link_tooltip" defaultMessage="Your current balance, minus any pending grants, pending exchanges, or assets invested in TIFF" />,
        url: '/my-account/transaction-summary',
        buttonName: 'View Transaction summary',
        pageName: 'Investment Dashboard'          
      }
    ];
    const tabConfig = function destObj(data, index, clicked, item) {
      return [
        {
          config: [
            {
              name: 'txnId',
              type: 'TitleGrid',
              gridWidth: '100',
              render: renderTitleGrid({
                data,
                each: 'txnId',
                label: 'Transaction Id',
                index: index,
                handleTitleClick: () => clicked(data, item)
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false
            },
            {
              name: 'enteredDate',
              type: 'Date',
              gridWidth: '50',
              render: renderDateGrid1({
                data,
                each: 'enteredDate',
                label: 'Entered date'
              }),
              ptop: false,
              pbottom: true
            },
            {
              name: 'exchangetype',
              gridWidth: '50',
              render: renderFixGrid1({
                data,
                each: 'exchangetype',
                label: 'Exchange type'
              }),
              ptop: false,
              pbottom: true
            },
            {
              name: 'allocationType',
              gridWidth: '50',
              render: renderFixGrid1({
                data,
                each: 'allocationType',
                label: 'Allocation type'
              }),
              ptop: false,
              pbottom: true
            },
            {
              name: 'status.extDescription',
              gridWidth: '50',
              render: renderFixGrid1({
                data,
                each: 'status.extDescription',
                label: 'Status'
              }),
              ptop: false,
              pbottom: true
            }
          ]
        },
        {
          config: [
            {
              name: 'exchScheduleId',
              type: 'TitleGrid',
              gridWidth: '100',
              render: renderTitleGrid({
                data,
                each: 'exchScheduleId',
                label: 'Exchange Schedule Id',
                index: index,
                handleTitleClick: () => clicked(data, item)
              }),
              noBorderBottom: true,
              ptop: false,
              pbottom: false
            },
            {
              name: 'exchangeCreateDate',
              type: 'Date',
              gridWidth: '50',
              render: renderDateGrid({
                data,
                each: 'exchangeCreateDate',
                label: 'Create date'
              }),
              ptop: false,
              pbottom: true
            },
            {
              name: 'exchangeStartDate',
              type: 'Date',
              gridWidth: '50',
              render: renderDateGrid({
                data,
                each: 'exchangeStartDate',
                label: 'Start date'
              }),
              ptop: false,
              pbottom: true
            },
            {
              name: 'noOfExchangesRemaining',
              gridWidth: '50',
              render: renderFixGrid({
                data,
                each: 'noOfExchangesRemaining',
                label: 'Number of Exchanges Remaining'
              }),
              ptop: false,
              pbottom: true
            },
            {
              name: 'nextScheduledExchangeDate',
              type: 'Date',
              gridWidth: '50',
              render: renderDateGrid({
                data,
                each: 'nextScheduledExchangeDate',
                label: 'Next scheduled exchange date'
              }),
              ptop: false,
              pbottom: true
            },
            {
              name: '',
              type: '',
              gridWidth: '50',
              render: renderFixGrid({
                data,
                each: '',
                label: ''
              }),
              ptop: false,
              pbottom: true
            },
            {
              name: 'status',
              gridWidth: '50',
              render: renderFixGrid({
                data,
                each: 'status',
                label: 'Status'
              }),
              ptop: false,
              pbottom: true
            }
          ]
        }
      ];
    };

    const tabPanes = [
      {
        title: 'Recent Exchanges',
        key: 1,
        destComponent: 'card',
        mobComponent: 'card',
        data: recentData,
        isLoading: isLoadingRecent
      },
      {
        title: 'Exchange Schedule',
        key: 2,
        destComponent: 'card',
        mobComponent: 'card',
        data: recurringData,
        isLoading: isLoadingRecurring
      }
    ];
    this.breadcrumbRoutes = () => {
      return [
        {
          routeName: 'Home',
          path: '/'
        },
        {
          routeName: () => <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="Investment Dashboard" property="field_page_title" defaultMessage="Investment Overview" />,
          path: ''
        }
      ];
    };

    return (      
      <ContentProvider types={[Types.PAGE_TITLE_DESCRIPTION]} pages={['Investment Dashboard', 'Current Balance', 'Available Balance', 'Market movement', 'Investment Performance']} data-test='investmentDashboard'>
      <InvestmentDashboardBody className='Analytics_investmentDashboard'>
        <FixedWidth>
          <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
        </FixedWidth>
        <div className='mb-50'>
          <DashboardSummary setPageTitle={this.setPageTitle.bind(this)} accData={accData} className='mb-50' />
        </div>
        <GreyBackgroundSection>
          <FixedWidth>
            <Row>
              <Col md={{ span: '8' }}>
                <BalanceCards
                  clicked={(e, pathName, query, selectedHeader) =>
                    this.goFromCardsToPage(e, pathName, query, selectedHeader)
                  }
                  grantsDashboard={true}
                  config={BalanceCardsConfiguration}
                  id={"anrBalanceCards"}
                />
              </Col>
              <Col md={{ span: '16' }} className='mt-xs-20'>
                <CommonCard>
                  <DashboardTabs
                    tabPanes={tabPanes}
                    tabConfig={tabConfig}
                    containerHeight='246px'
                    transactionClicked={item => this.goToExchanges(item)}
                    className="tbDashboard"
                  />
                  <SemiDarkerDivider className='my0' />
                  <TabFooter>
                    <a className='link-navigator tool-tip' tabindex='0' title='' id="anrTabFooterToolTip" >
                      <Link to='/investments/exchange-activity'>
                        <LinkNavigatorButton
                          styling='ml3 mt1 mb1'
                          buttonName='View Exchange Activity'
                          id="anrViewExchangeActivity"
                        />
                      </Link>
                    </a>
                    <ContentProvider types={[Types.PAGE_DISCLAIMERS]} pages={['View Exchange Activity']}>
                      <NotifyText>                        
                        <ContentMessage messageId="InvestDashboardMsg" type={[Types.PAGE_DISCLAIMERS]} html={true} page="View Exchange Activity" property="field_disclaimer_content" defaultMessage="Transactions displayed above are from last 90 days."/>
                      </NotifyText>
                    </ContentProvider>
                  </TabFooter>
                </CommonCard>
              </Col>
            </Row>
            <CarouselController>
              <CarouselComponent />
            </CarouselController>
            <Row className='expanded-width-01'>
              <Col md={{ span: '8' }}>
              <TooltipWrapper text={disabledText1(accData)}
                    placement={
                      window.screen.availWidth >= 320 &&
                      425 >= window.screen.availWidth
                        ? 'top'
                        : 'right'
                    }
                    element={
                      <GeneralCustomDiv className="expanded-width">
                  <GeneralButton
                    type="primary"
                    text="Recommend an exchange"
                    leftArrow={false}
                    width={'100%'}
                    disabled={disabledValidator(accData)}
                    mobWidth={'100%'}
                    onClick={() => this.goToPage('/investments/recommend-an-exchange', '', 'Recommend an exchange')}
                    id={"btnRecommendAnExchange"}
                  />
                </GeneralCustomDiv>
                    }
                  />
              </Col>
            </Row>
          </FixedWidth>
        </GreyBackgroundSection>
        <FixedWidth>
          <SectionTopHeading className='mt3-125 mb0'>
            Your Allocation
          </SectionTopHeading>
          <InvestmentPerformanceWrapper>
            <IDSectionHeading className=''>                
              <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="Investment Performance" property="field_page_title" defaultMessage="Investment Performance"/>
            </IDSectionHeading>
            <MarketMovementWrapper style={{ display:'none'}}>
              <MarketMovementTitle>
              <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="Market movement" property="field_page_title" defaultMessage="Market movement" /> :&nbsp;
              </MarketMovementTitle>
              <MarketMovementValue>
                {accData.marketMovement.toString() === '0' ? (
                  <> $0.00 </>
                ) : (
                  this.dolarFormater(accData.marketMovement, '$')
                )}
              </MarketMovementValue>

              <MarketMovementTooltip
                overlayClassName='market-movemet-tooltip tolltip_arrow'
                placement='bottomRight'
                title={<ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} html={true} page="Market movement" property="field_link_tooltip" defaultMessage="This shows market movement year to date, with a two-day lag." />}
                autoAdjustOverflow={true}
                
              >
                <TooltipCircle src={tooltipIcon} alt = "tooltipIcon"/>
              </MarketMovementTooltip>
            </MarketMovementWrapper>
          </InvestmentPerformanceWrapper>
          <Row>
            <Col lg={24} md={24} xs={0}>
              <InvestmentPerformance
                main_accdata={accData}
                accData={accData.investmentPools}
                isLoadingAccount={isLoadingAccount}
                history={this.props.history}
              />
            </Col>
            <Col lg={0} md={0} xs={24}>
              <InvestmentPerformanceMobile
                main_accbalance={accData.currentBalance}
                accData={accData.investmentPools}
                isLoadingAccount={isLoadingAccount}
                history={this.props.history}
              />
            </Col>
          </Row>
          {accData.investmentPools &&accData.investmentPools.length>0?<Row>
            <ContentProvider types={[Types.PAGE_DISCLAIMERS]} pages={['Investment allocation']}>
              <InfoMsg className="infoMsg">                
                <ContentMessage type={[Types.PAGE_DISCLAIMERS]} html={true} page="Investment allocation" property="field_disclaimer_content" defaultMessage="Investment allocations that fall below .0049% of your total balance will be displayed as 0.0%."/>
              </InfoMsg>
            </ContentProvider>
          </Row>: null }          
          <Row className="mb4">
            <Col lg={8} md={9} sm={12}>
              <span className='tool-tip' tabindex='0' title=''>
                <GeneralCustomDiv className="mr-01">
                  <GeneralButton
                    data-test="viewInvestmentPerformance"
                    type="secondary"
                    text="View Investment Performance"
                    leftArrow={false}
                    width="100%"
                    disabled={false}
                    mobWidth="100%"
                    onClick={this.goToIOD.bind(this)}
                    id="btnViewInvestmentPerformance"
                    className="mr-01"
                    inverted={true}
                  />
                </GeneralCustomDiv>
              </span>
            </Col>
          </Row>
        </FixedWidth>          
      </InvestmentDashboardBody>
      </ContentProvider>      
    );
  }
}

InvestmentDashboard.propTypes = {
  accData: PropTypes.object,
  accountID: PropTypes.string,
  isLoadingAccount: PropTypes.bool,
  isLoadingRecent: PropTypes.bool,
  isLoadingRecurring: PropTypes.bool,
  recentData: PropTypes.oneOfType([PropTypes.array,PropTypes.object]),
  recurringData: PropTypes.oneOfType([PropTypes.array,PropTypes.object]),
  requestData: PropTypes.func,
  selectHeader: PropTypes.func,
  goFromCardsToPage: PropTypes.func,
  goToExchanges: PropTypes.func,
  goToPage: PropTypes.func,
  goToIOD: PropTypes.func,
  main_accbalance: PropTypes.array
}

const mapStateToProps = state => ({  
...investmentDashboardDerivedStates(state.toJS())
});

const mapDispatchToProps = dispatch => ({
  requestData: data => dispatch(fetchInvestmentDashBoardData(data)),
  selectHeader: data => dispatch(selectHeader(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(InvestmentDashboard)
);
